import useAuth from "./useAuth";

// Backend permission key'lerini lowercase'e normalize eder; frontend'in de
// büyük/küçük harf farketmeden karşılaştırması gerek (ör. "doctorTemplates:read"
// backend'de "doctortemplates:read" olarak gelir).
const _norm = (s) => String(s || "").trim().toLowerCase();

export const useHasPermission = (...permissions) => {
  const { auth } = useAuth();
  if (!auth) return false;
  if (auth.role === "Admin") return true;
  const userPerms = (auth.permissions || []).map(_norm);
  return permissions.some((p) => userPerms.includes(_norm(p)));
};

export const useHasAllPermissions = (...permissions) => {
  const { auth } = useAuth();
  if (!auth) return false;
  if (auth.role === "Admin") return true;
  const userPerms = (auth.permissions || []).map(_norm);
  return permissions.every((p) => userPerms.includes(_norm(p)));
};
